export const HOME = '/befa-art'